import type { NsDict } from '../ru';

export const admin: NsDict<'admin'> = {
  title: 'Administration',
  signedIn: 'You are signed in as administrator',
  noPlay: 'The administrator does not take part in games.',
  'tab.overview': 'Overview',
  'tab.users': 'Users',
  'tab.games': 'Games',

  'data.title': 'Data',
  'data.mode': 'Mode',
  'data.modeReplay': 'history',
  'data.modeLive': 'live',
  'data.modeReplayHint': 'historical replay; results do not count towards the main mode ranking',
  'data.source': 'Source',
  'data.sourceSynthetic': 'synthetic',
  'users.total': 'Total',
  'users.online': 'Online',
  'users.new24h': 'New in 24 h',
  'users.new7d': 'New this week',
  'users.active7d': 'Played this week',
  'users.banned': 'Banned',
  'users.withPassword': 'With password',
  'users.withSso': 'Via services',
  'games.total': 'Total',
  'games.last24h': 'Last 24 h',
  'games.completed': 'Completed',
  'games.cancelled': 'Cancelled',
  'games.avgPlayers': 'Average players',
  'games.humanShare': 'Human share',
  'games.humanShareHint': 'humans among all participants (the rest are bots)',
  'credits.title': 'Credits',
  'credits.bank': 'House account',
  'credits.bankHint': 'accumulated commission',
  'credits.commissionTotal': 'Total commission',
  'credits.granted': 'Granted to players',
  'credits.grantedHint': 'starting and restored balances',
  'credits.inPlay': 'Currently in pots',
  'credits.inPlayHint': 'contributed to unfinished games',
  'credits.potTotal': 'Pot turnover',
  'rooms.title': 'Right now',
  'rooms.open': 'Open tables',
  'rooms.playing': 'Games in progress',
  'rooms.seated': 'People at tables',
  'rooms.spectators': 'Spectators',
  'daily.games': 'Games by day',
  'daily.gamesValue': '{n} game|{n} games',
  'daily.commission': 'Commission by day',
  'byTable.title': 'By table',
  'byTable.empty': 'There have been no games yet.',
  'byTable.ante': 'Ante',
  'byTable.games': 'Games',
  'byTable.pot': 'Turnover',
  'byTable.commission': 'Commission',
  'top.title': 'Top players',
  'top.empty': 'Nobody has played yet.',
  'top.games': '{n} game|{n} games',

  'list.banPrompt': 'Reason for banning {name} (visible to the player):',
  'list.searchPlaceholder': 'Search by name, username or id',
  'list.searchLabel': 'Search users',
  'list.filterAll': 'All',
  'list.filterOnline': 'Online',
  'list.filterBanned': 'Banned',
  'list.empty': 'Nobody found.',
  'list.colPlayer': 'Player',
  'list.colLogin': 'Sign-in',
  'list.colActivity': 'Activity',
  'list.colGames': 'Games',
  'list.colWinRate': 'Win rate',
  'list.colNet': 'Net result',
  'list.colBalance': 'Balance',
  'list.tagOnline': 'online',
  'list.tagBanned': 'banned',
  'list.sessionOnly': 'session only',
  'list.now': 'now',
  'list.profile': 'Profile',
  'list.ban': 'Ban',
  'list.unban': 'Unban',
};
